import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    modal: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    modalContent: {
      width: "691px",
      backgroundColor: theme.white50,
      border: `1px solid ${theme.gray200}`,
      borderRadius: "6px",
      maxHeight: "80vh",
      overflow: "hidden",
    },
    searchAndCloseWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(6, 8),
      gap: theme.spacing(5),
      borderBottom: `1px solid ${theme.gray200}`,
    },
    search: {
      height: 0,
      width: "100%",
      padding: 0,
      borderBottom: "none",
    },
    title: {
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 500,
      color: theme.gray500,
      padding: theme.spacing(8, 8, 6),
    },
    olTabs: {
      padding: theme.spacing(0, 8, 8),
      margin: 0,
    },
    list: {
      maxHeight: "400px",
      overflowY: "auto",
      paddingTop: 0,
    },
    menuItem: {
      fontSize: "16px",
      lineHeight: "24px",
      color: theme.gray800,
    },
    loader: {
      position: "unset",
    },
    categoryTitle: {
      color: theme.gray500,
      fontWeight: 500,
      padding: theme.spacing(6, 8),
    },
    categoryItem: {
      padding: theme.spacing(4, 8),
      cursort: "pointer",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
      },
      "& a": {
        color: theme.gray800,
        fontSize: 16,
        fontWeight: 400,
        textDecoration: "none",
        padding: theme.spacing(4),
      },
    },
    categoryList: {
      overflowY: "scroll",
      maxHeight: "calc(80vh - 50px)",
    },
    lastSearchTitle: {
      padding: theme.spacing(6, 8, 4),
      color: theme.gray500,
      fontSize: 14,
      fontWeight: 500,
    },
    linkWrapper: {
      padding: theme.spacing(4, 12),
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
      },
    },
    link: {
      textDecoration: "none",
      display: "flex",
      gap: "8px",
    },
    linkName: {
      color: theme.gray800,
      fontSize: 16,
    },
    linkDesc: {
      color: theme.gray500,
    },
    subType: {
      fontStyle: "italic",
      color: theme.gray300,
    },
  }),
);
